<footer id="footer">
    <div class="container">
        <!-- <div class="row trust-badge-logo-wrapper">
            <div class=" col-lg-8 col-md-12 col-sm-12 trust-badge-logo">
                <a href="https://clutch.co/profile/vidhema-technologies-pte#summary" target="_blank"><img src="assets/images/202132210360-270clutch-logo.png" alt="Clutch Logo"></a>
                <a href="https://www.topdevelopers.co/profile/vidhema" target="_blank"><img src="assets/images/202132211127-634topdevelopers.png"
                    alt="Top Developers Logo"></a>
                
                <a href="https://www.goodfirms.co/company/vidhema-technologies-pte-ltd" target="_blank"><img src="assets/images/footer-client-logo4.png" alt="Good Firms Logo"></a>
                <a href="https://www.vidhema.com/ecommerce-development.html" target="_blank"><img style="height: 30px;" src="assets/images/20231614288-880adobe_bronze_solution_partner.png" alt="Adobe Partner"></a>
                <a href="https://www.vidhema.com/hire-shopify-developers.html" target="_blank"><img style="height: 30px;" src="assets/images/2022913121729-253shopify-partner-logo.jpg" alt="Shopify Plus"></a>
                <a href="https://firmsfinder.co/mobile-app-development-companies/" target="_blank"><img style="height: 30px;" src="assets/images/202296173811-832firmsfinder_logo_white.png" alt="FirmsFinder"></a>
 
            </div>
        </div> -->
        <div class="row progress-wrapper">
            <div class="col-md-12 col-sm-12  progress-content">
                <div class="star-icon text-center">
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <i class="fa fa-star" aria-hidden="true"></i>
                </div>
                <p class="progress-text">Rate Us Overall client rating is 4.9 out of 5.0 for Vidhema Technologies by
                    1.5K+ clients.</p>
            </div>
        </div>
        <div class="row contact-wrapper">

            <div class="col-md-8 col-sm-12 quick-links-container">
                <div class="row quick-links">
                    <div class="col-md-4 col-sm-4 col-xs-6">
                        <div class="links-heading">Quick Links</div>
                        <ul>
                            <li><a routerLink="/about-us.html">About us</a></li>
                            <li><a routerLink="/contact-us.html">Contact Us</a></li>
                            <li><a routerLink="/blog">Blog</a></li>
                            <li><a routerLink="/career.html">Career</a></li>
                            <li><a routerLink="/portfolio.html">Our Portfolio</a></li>
                            <li><a routerLink="/privacy-policy.html">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-6">
                        <div class="links-heading">Services</div>
                        <ul>
                            <li><a routerLink="/nft-development.html">NFT Development Company</a></li>
                            <li><a routerLink="/augumented-reality.html">AR Development Company</a></li>
                            <li><a routerLink="/ecommerce-development.html">Ecommerce Development Services</a></li>
                            <li><a routerLink="/web-application-development.html">Web App Development Services</a></li>
                        </ul>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-12">
                        <div class="links-heading">Hire Resource</div>
                        <ul>
                            <li><a routerLink="/hire-nft-ecommerce-developers.html">Hire NFT Developers</a></li>
                            <li><a routerLink="/hire-magento-developers.html">Hire Magento Developers</a></li>
                            <li><a routerLink="/hire-shopify-developers.html">Hire Shopify Developers</a></li>
                            <li><a routerLink="/hire-react-js-developers.html">Hire React JS Developers</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-sm-12 communicate">
                <h3 style="margin-bottom: 20px;"> Get in Touch with Us</h3>
                <h4 style="color: #ffffff;font-size: 14px;">For HR Inquiry</h4>
                <h2 class="call_us-h2">
                    <img src="assets/images/in.png" title="in" alt="Singapore" style="margin-right: 10px;">
                    <a href="tel:+919352372844" style="width: 100%;margin: 10px auto;">(+91)9352372844</a>
                </h2>
                <h4 style="color: #ffffff;font-size: 14px;">For Sales / Consultation</h4>
                <h2 class="call_us-h2">
                    <img src="assets/images/sg.png" title="sg" alt="Singapore" style="margin-right: 10px;">
                    <a href="tel:+6580151152">(+65)80151152</a>
                </h2>
                <h2 class="call_us-h2">
                    <img src="assets/images/in.png" title="in" alt="Singapore" style="margin-right: 10px;">
                    <a href="tel:+91-7976109930">(+91)7976109930</a>
                </h2>
                <div class="detail_fine">
                    <i class="fa fa-skype skype" aria-hidden="true"></i>
                    <a href="skype:live:vidhemasolutions?call">live:vidhemasolutions</a><br>
                    <i class="fa fa-envelope email" aria-hidden="true"></i>
                    <a href="mailto:sales@vidhema.com?Subject=Hello%20again">sales@vidhema.com</a><br>
                    <i class="fa fa-youtube-play youtube" aria-hidden="true"></i>
                    <a href="https://www.youtube.com/@vidhematechnologies6060" target="_blank">Vidhema Technologies</a>
                </div>
            </div>
        </div>
    </div>

    <div class="container copyright-container">
        <div class="row copyright">
            <div class="col-md-7 col-sm-8 col-xs-12">
                <div class="copright_text"> Copyright © <a href="javascript:void(0);"> 2025 Vidhema Technologies
                        Pte. Ltd.</a> All Rights Reserved.<br>
                </div>
            </div>
            <div class="col-md-5 col-sm-4 col-xs-12 social_blockfooter">
                <a href="https://www.linkedin.com/company/vidhema-solutions?originalSubdomain=in" target="_blank" title="LinkedIn">
                    <i class="fa fa-linkedin linkdin" aria-hidden="true"></i>
                </a>
                <a href="https://www.instagram.com/vidhematechnologies/" target="_blank" title="Instagram">
                    <i class="fa fa-instagram" aria-hidden="true"></i>
                </a>
                <a href="https://www.facebook.com/pages/category/Computer-Company/Vidhema-Solutions-125764551621381/ "
                    target="_blank" title="Facebook">
                    <i class="fa fa-facebook facebook" aria-hidden="true"></i>
                </a>
                <a href="https://twitter.com/Vidhema1" target="_blank" title="Twitter">
                    <i class="fa fa-twitter twitter" aria-hidden="true"></i>
                </a>
                <a href="https://www.youtube.com/@vidhematechnologies6060"
                 target="_blank" title="youtube">
                 <i class="fa fa-youtube youtube" aria-hidden="true"></i>
                 </a>
            </div>
        </div>
    </div>
</footer>